import React, { useEffect } from "react";
import Interweave from "interweave";
import ReactPlayer from "react-player";

import {
  Typography,
  Box,
  Avatar,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

import { pink } from "@mui/material/colors";

function VideoBlockView({ idx, block, allowEditing, onEdit }) {
  const [url, setUrl] = React.useState();
  const [progress, setProgress] = React.useState();

  useEffect(() => {
    if (block.data) {
      _checkResourcePrepStatus(block.data);
    }
  }, []);

  const _setUrl = async (resourceId) => {
    const resources = await global.dipClient.getResources([ resourceId ]);
    if (resources && resources.length > 0 && resources[0].status === 'READY') {
      if (resources[0].transcodedUrl) {
        console.log("_setUrl: url = " + resources[0].transcodedUrl);
        setUrl(resources[0].transcodedUrl);
        return true;
      }
      else {
        console.log("_setUrl: url = " + resources[0].url);
        setUrl(resources[0].url);
        return true;
      }
    }
    return false;
  };

  const _checkResourcePrepStatus = async (resourceId) => {
    console.log("_checkResourcePrepStatus: resourceId = " + resourceId);

    if (await _setUrl(resourceId)) return;

    setProgress(0);
    while (true) {
      const resourceStatus = await global.dipClient.getResourceStatus([ resourceId ]);
      if (!resourceStatus) {
        console.log("_checkResourcePrepStatus: invalid resourceStatus");
        break;
      }
      if (resourceStatus[0].status === 'READY') break;

      const p = resourceStatus[0].prepProgress ? resourceStatus[0].prepProgress : 0;
      console.log("_checkResourcePrepStatus: progress = " + p);
      setProgress(p);

      await new Promise(resolve => setTimeout(resolve, 1000));
    }
    setProgress(100);

    if (await _setUrl(resourceId)) return;
  };

  function getEditButton() {
    if (allowEditing) {
      return (
        <IconButton
          style={{
            position: "absolute",
            top: 20,
            left: 20,
          }}
          size="large"
          onClick={(e) => onEdit(block)}
        >
          <Avatar sx={{ bgcolor: pink[500] }}>
            <EditIcon />
          </Avatar>
        </IconButton>
      );
    }
    return null;
  }

  const style = {
    transform: `translateX(${block.translationX}%) scale(${block.scale})`,
  };

  const renderPlayer = () => {
    if (!url) {
      if (progress === undefined) return null;
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            width: "100%",
            height: `${(140 / 360) * 100}vw`,
            backgroundColor: "black",
          }}
        >
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="body1" color="textSecondary">
              {"아직 변환 중입니다"}
            </Typography>
            <LinearProgress
              id={`${block.name}-linear`}
              sx={{ width: "100%", marginTop: "16px" }}
              variant="determinate"
              color="secondary"
              value={progress}
            />
          </Box>
        </Box>
      );
    }

    return (
      <ReactPlayer
        id={`${block.name}-player`}
        controls
        width="100%"
        height="(140/360 * 100)vw"
        style={{
          top: 0,
          left: 0,
          width: "100%",
          marginBottom: "-5px",
          objectFit: "contain",
        }}
        url={url}
      />
    );
  };

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: block.backgroundColor,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div id={block.name} style={style}>
        {/* <Interweave content={block.data ? block.data : ''}/> */}
        {renderPlayer()}
      </div>
      {getEditButton()}
    </div>
  );
}

export default VideoBlockView;
